import type { SVGProps } from "react";
export interface PinLocation02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PinLocation02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PinLocation02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.89 16.127a1.126 1.126 0 0 1 1.294-.925c1.547.256 2.927.66 3.952 1.2.93.49 1.989 1.325 1.989 2.598 0 .906-.552 1.59-1.135 2.05-.597.47-1.39.845-2.27 1.139-1.772.59-4.148.936-6.72.936s-4.948-.346-6.72-.936c-.88-.294-1.673-.668-2.27-1.138-.547-.432-1.067-1.06-1.13-1.884L1.876 19l.012-.233c.12-1.143 1.105-1.905 1.977-2.364 1.025-.54 2.405-.945 3.952-1.201a1.125 1.125 0 0 1 .368 2.22c-1.415.235-2.537.585-3.27.971-.604.318-.747.545-.78.608.022.044.088.14.27.283.314.248.839.52 1.587.77 1.486.496 3.611.82 6.009.82s4.523-.324 6.009-.82c.748-.25 1.273-.522 1.588-.77.18-.142.245-.239.268-.283-.034-.064-.177-.29-.778-.608-.734-.386-1.856-.736-3.271-.97a1.126 1.126 0 0 1-.926-1.296Z"
      />
      <path
        fill={color}
        d="M15.375 6.5a3.375 3.375 0 1 0-6.75 0 3.375 3.375 0 0 0 6.75 0m2.25 0a5.63 5.63 0 0 1-4.5 5.512V18a1.125 1.125 0 0 1-2.25 0v-5.988A5.627 5.627 0 0 1 12 .875 5.625 5.625 0 0 1 17.625 6.5"
      />
    </svg>
  );
}
